export const isBillingPre = (profile) => {
  return profile.client?.billing.type === "pre" ?? false;
};
export const hasPermissionRoute = (profile, path) => {
  if (!path) {
    return true;
  }
  let basePath = path;
  let read = false;
  let write = false;
  let writeUp = false;
  let creating = false;
  let editing = false;
  const baseRoutesAllowed = [
    "/",
    // "/batch",
    // "/batch/robots",
    // "/batch/query",
    "/dashboard",
    "/meu-cadastro",
    "/historico",
    "/historico/:id",
    "/historico-combo",
    "/historico-combo/:id",
    "/historico-lote",
    "/historico-comunicado-venda",
    "/historico-atpve",
    "/historico-negativacao",
    "/historico-consultas-ondemand",
    "/historico-consultas-ondemand/:id",
    "/relatorio-gestao-financeira",
    "/relatorio-gestao-campanhas",
    "/impressao",
    "/impressao/consulta/:id",
    "/impressao/pdf/consulta/:id",
    "/impressao/combo-consultas/:id",
    "/financeiro",
    "/financeiro/meus-recebimentos",
    "/financeiro/meus-recebimentos/detalhe-fatura/:id",
    // "/financeiro/gestao-contas",
    "/financeiro/minha-conta",
    "/financeiro/minha-conta/detalhe-fatura/:id",
    "/financeiro/minha-conta/extrato",
    "/financeiro/minha-conta/faturas",
    "/financeiro/ordens-de-pagamento",
    "/financeiro/contas-correntes",
    "/notificacoes",
    "/termos-aceite",
    "/atendimento",
    "/atendimento/:id",
    "/atendimento/cadastrar",
    "/log",
    "/consultas-contratadas",
    "/busca-avancada",
    "/busca-avancada/pf",
    "/busca-avancada/pj",
  ];
  const routesOnlyPrepago = ["/financeiro/solicitacoes-creditos"];

  const routesDisablePrepago = ["/financeiro/meus-recebimentos"];

  if (path.includes("/cadastrar")) {
    basePath = basePath.substring(0, basePath.indexOf("/cadastrar"));
    creating = true;
  }

  if (path.includes("/editar")) {
    basePath = basePath.substring(0, basePath.indexOf("/editar"));
    if (path.includes("/:id")) {
      editing = true;
    }
  }

  if (!isBillingPre(profile)) {
    if (routesOnlyPrepago.includes(basePath)) {
      return false;
    }
  }

  if (isBillingPre(profile)) {
    if (routesDisablePrepago.includes(basePath)) {
      return false;
    }
  }

  if (baseRoutesAllowed.includes(basePath)) {
    return true;
  }

  if (basePath.indexOf("/consulta/") !== -1) {
    return true;
  }

  if (basePath.indexOf("/combo-consultas/") !== -1) {
    return true;
  }

  if (basePath.indexOf("/consultas-ondemand/") !== -1) {
    return true;
  }

  const perm = profile.permissions?.find((e) => e.path === basePath);

  let _return = false;
  if (perm) {
    for (let p of ["c", "r", "u", "d"]) {
      if (perm.permissions[p]) {
        read = true;
        if (["c"].includes(p)) {
          write = true;
        }
        if (["u", "d"].includes(p)) {
          writeUp = true;
        }
      }
    }

    if (editing || creating) {
      if (editing && writeUp) {
        _return = true;
      } else if (creating && write) {
        _return = true;
      }
    } else {
      if (read) {
        _return = true;
      }
    }

    if (_return && perm.onlyWhiteLabel && !profile.client.isWhiteLabel) {
      _return = false;
    }

    if (_return && perm.onlyWhiteLabelPrimary && !profile.client.isWhiteLabelPrimary) {
      _return = false;
    }
  }
  return _return;
};

export const hasPermission = (path, action) => {};

export const hasPermissionChildRoute = (profile, children) => {
  for (let child of children) {
    if (hasPermissionRoute(profile, child.path)) {
      return true;
    }
  }
  return false;
};

export const hasPermissionConsultas = (profile) => {
  if (profile && profile.menuQueries && profile.menuQueries.length > 0) {
    return true;
  }

  if (profile && profile.menuProductQueries && profile.menuProductQueries.length > 0) {
    return true;
  }

  if (profile && profile.menuOndemandQueries && profile.menuOndemandQueries.length > 0) {
    return true;
  }

  return false;
};
